<template>
    <div id="permit_type_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                        <span class="page-title" id="vehiclePermitTypeHeader" v-if="$route.params.id > 0">Update Debt Note</span>
                        <span class="page-title" id="vehiclePermitTypeHeader" v-else>Add Debt Note</span>
                        <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backScreen" >
                               <i class="fp-back"> </i> Back
                        </button>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content verhicle-permit-crud">
                        <section class="internal-container border-top-table-fl">
                             <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="debtNoteForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id">Financier:</label>
                                        <v-select v-model="vendor_id" name="vendor_id" label="text" :filterable="false"
                                        :options="vendorArr" @search="onSearchVendor"
                                        placeholder="Select Vendor Code or Name" class="custom-ci-auto-search" :disabled="isEditMode">
                                                <template slot="no-options">
                                                    Search Financier Code or Name...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                        </v-select>
                                        <div class="field-error">{{ vendor_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="ref_number">Reference Number:</label>
                                        <input type="text" class="form-control" v-model="ref_number" id="ref_number"
                                        placeholder="Reference Number" name="ref_number" :disabled="isEditMode">
                                        <div class="field-error">{{ref_number_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="note_amount">Note Amount:</label>
                                        <input type="text" class="form-control" v-model="note_amount" id="note_amount"
                                        placeholder="Enter Note Amount" name="note_amount"
                                        @keypress="isAmountCheck($event, true, 9999999)"
                                        @blur="note_amount = leaveFocus($event)"
                                        @focus="note_amount = enterVal($event)"
                                         :disabled="isEditMode">
                                        <div class="field-error">{{ note_amount_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="interest_rate">Interest Rate:</label>
                                        <input type="text" class="form-control" v-model="interest_rate"
                                        id="interest_rate"
                                        placeholder="Enter Interest Rate" name="interest_rate"
                                        @keypress="isAmountCheck($event, true, 99.99)" :disabled="isFixed">
                                        <div class="field-error">{{ interest_rate_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="interest_rate_type">Interest Rate Type:</label>
                                        <v-select v-model="interest_rate_type" name="interest_rate_type"
                                        label="text" :filterable="false"
                                        :options="interestRateTypeArr"
                                        placeholder="Select Interest Rate Type" class="custom-ci-auto-search" :disabled="isEditMode">
                                        </v-select>
                                        <div class="field-error">{{ interest_rate_type_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="interest_calc_method">Interest Calculation Method:</label>
                                        <v-select v-model="interest_calc_method" name="interest_calc_method"
                                        label="text" :filterable="false"
                                        :options="interestcalcMethodArr"
                                        placeholder="Select Interest Calculation Method" class="custom-ci-auto-search" :disabled="isEditMode">
                                          <template slot="no-options">
                                              Search Interest Calculation Method
                                          </template>
                                          <template slot="option" slot-scope="option">
                                              <div class="d-center">
                                                  {{ option.text }}
                                              </div>
                                          </template>
                                          <template slot="selected-option" slot-scope="option">
                                              <div class="selected d-center">
                                                  {{ option.text }}
                                              </div>
                                          </template>
                                        </v-select>
                                        <div class="field-error">{{ interest_calc_method_error_msg }}</div>
                                    </div>


                                    <div class="col form-group">
                                        <label class="control-label require" for="interest_calc_method">Payment Type:</label>
                                        <v-select v-model="payment_type" name="payment_type"
                                        label="text" :filterable="false"
                                        :options="paymentTypeArr"
                                        placeholder="Select Payment Type" class="custom-ci-auto-search" :disabled="isEditMode">
                                          <template slot="no-options">
                                              Search Payment Type
                                          </template>
                                          <template slot="option" slot-scope="option">
                                              <div class="d-center">
                                                  {{ option.text }}
                                              </div>
                                          </template>
                                          <template slot="selected-option" slot-scope="option">
                                              <div class="selected d-center">
                                                  {{ option.text }}
                                              </div>
                                          </template>
                                        </v-select>
                                        <div class="field-error">{{ payment_type_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="principal_payment">Principal Payment Type:</label>
                                        <v-select v-model="principal_payment" name="principal_payment"
                                        label="text" :filterable="false"
                                        :options="principalPaymentTypeArr"
                                        placeholder="Select Principal Payment Type" class="custom-ci-auto-search" :disabled="isEditMode">
                                          <template slot="no-options">
                                              Search Principal Payment Type
                                          </template>
                                          <template slot="option" slot-scope="option">
                                              <div class="d-center">
                                                  {{ option.text }}
                                              </div>
                                          </template>
                                          <template slot="selected-option" slot-scope="option">
                                              <div class="selected d-center">
                                                  {{ option.text }}
                                              </div>
                                          </template>
                                        </v-select>
                                        <div class="field-error">{{ principal_payment_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="financing_start_date">Financing Start Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="financing_start_date" name="financing_start_date"
                                            v-model="financing_start_date" :config="optionsDate" :disabled="isEditMode"></date-picker>
                                            <label for="financing_start_date"
                                            class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ financing_start_date_error }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="first_principal_payment">First Principal Payment:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="first_principal_payment"
                                            name="first_principal_payment" v-model="first_principal_payment"
                                            :config="optionsDate" :disabled="isEditMode"></date-picker>
                                            <label for="first_principal_payment"
                                            class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ first_principal_payment_date_error }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="duration">Duration: (months)</label>
                                        <input type="text" class="form-control" v-model="duration"
                                        id="duration"
                                        placeholder="Enter Duration" name="duration"
                                        @keypress="isNumber($event)" :disabled="isEditMode">
                                        <div class="field-error">{{ duration_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="duration">Number of Payments:</label>
                                        <div style="margin-top: 5px;">{{ number_of_payment }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="end_date">End Date:</label>
                                        <div style="margin-top: 5px;">{{ end_date }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="asset">Asset Number:</label>
                                        <!-- <input type="text" class="form-control" v-model="asset" id="asset"
                                        placeholder="Asset Number" name="asset" :disabled="isEditMode"> -->
                                        <v-select v-model="asset" name="asset" label="text" :filterable="false"
                                                  :options="vehicleArr" @search="onSearchVehicle"
                                                  placeholder="Select Asset Number" class="custom-ci-auto-search" :disabled="isEditMode">
                                            <template slot="no-options">
                                                Search Asset Number...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{asset_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="fixed_payment">Fixed Payment Amount:</label>
                                        <input type="text" class="form-control" v-model="fixed_payment"
                                        id="fixed_payment"
                                        placeholder="Enter Fixed Payment Amount" name="fixed_payment"
                                        @keypress="isAmountCheck($event)"
                                        @blur="fixed_payment = leaveFocus($event)"
                                        @focus="fixed_payment = enterVal($event)"
                                        :disabled="isEditMode">
                                        <div class="field-error">{{ fixed_payment_error_msg }}</div>
                                    </div>


                                    <div class="col form-group">
                                      <button type="submit" class="btn btn-secondary mt-4"
                                      v-on:click.prevent="calculation" >
                                          Calculate
                                      </button>
                                      <div class="field-error">{{error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="total_interest">Total Interest:</label>
                                        <div style="margin-top: 5px;">{{ total_interest }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="residual_amount">Residual Amount:</label>
                                        <div style="margin-top: 5px;">{{ residual_amount }}</div>
                                    </div>

                                     <div class="col form-group">
                                        <div class="custom-checkbox mt-4">
                                            <label class="checkbox-custom">
                                                <input type="checkbox" v-model="balloon_payment" id="balloon_payment" name="balloon_payment" :disabled="isEditMode">  Balloon Payment
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>



                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createdebtNoteBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="createDebtNote(flag='update')" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>

                                    <button type="submit" id="createdebtNoteBtn" v-else class="btn btn-primary" v-on:click.prevent="createDebtNote" >
                                    <i class="fp-save"> </i>  Save
                                    </button>

                                    <button type="submit" id="createAndContinuedebtNoteBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="createDebtNote(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>

                                    <button type="submit" id="canceldebtNoteBtn" class="btn btn-tertiary" v-on:click.prevent="backScreen" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>

                             </form>

                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>

<script>

import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';

import {contractMixins} from '../../mixins/contractMixins';
import moment from 'moment';
// Vue.use(Toaster);
// Vue.use(moshaToast)


export default {
  name: "DebtNoteCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Debt Note | " +process.env.COPYRIGHT_NAME : "Create Debt Note | " +process.env.COPYRIGHT_NAME
    }
  },
  components: {
        // Toaster,
    },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading:false,
    vendorArr: [],
    vendor_id: '',
    vendor_error_msg: '',
    ref_number: '',
    ref_number_error_msg: '',
    note_amount: '',
    note_amount_error_msg: '',
    interest_rate_error_msg: '',
    interest_rate: '',
    interest_rate_type_error_msg: '',
    interest_rate_type: '',
    interestRateTypeArr: ['Fixed', 'Variable'],
    interest_calc_method: '',
    interest_calc_method_error_msg: '',
    interestcalcMethodArr: [{ text: 'A | Actual / Actual', value: 'A'}, { text: 'B | 30 / 360', value : 'B'},
    {text : 'C | Actual / 360', value: 'C'}, {text : 'D | 30 / 365', value: 'D'}],
    payment_type_error_msg: '',
    payment_type: '',
    paymentTypeArr: [{ text: 'B | Both Payment Type', value: 'B'},
                  {text : 'F | Fixed Payment', value: 'F'},
                  {text : 'L | Lease Payment', value: 'L'}],
    principalPaymentTypeArr: [{ text: 'F | Fixed Principal', value: 'F'},
                  { text: 'V | Variable Principal', value : 'V'}],
    principal_payment_type_error_msg: '',
    principal_payment: '',
    principal_payment_error_msg: '',
    financing_start_date_error: '',
    financing_start_date: '',
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
        showClose: true,
    },
    first_principal_payment: '',
    first_principal_payment_date_error: '',
    duration: '',
    number_of_payment: '',
    duration_error_msg: '',
    end_date: '',
    asset_error_msg: '',
    asset: '',
    fixed_payment_error_msg: '',
    fixed_payment: '',
    total_interest: '',
    residual_amount: '',
    balloon_payment: false,
    listOfIntereset: [],
    error_msg: '',
    isEditMode: false,
    isFixed: false,
    lastInstalment: '',
    vehicleArr:[]
  }),
  watch: {
    permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_debt_note') {
                        self.cantAccessPage = true;
                    }
                }
            }

    },
    // first_principal_payment: function(first_principal_payment) {
    //   var self = this;
    //   if(self.first_principal_payment != null && self.first_principal_payment != '' && self.duration != null && self.duration != '') {
    //     self.first_principal_payment = new Date(self.first_principal_payment);
    //     var newDate = new Date(self.first_principal_payment.setMonth(self.first_principal_payment.getMonth()+self.duration));
    //     self.end_date = newDate;
    //   }
    // },
    balloon_payment: function (balloon_payment) {
      var self = this;
      if(self.balloon_payment && self.duration > 0) {
        self.number_of_payment = parseInt(self.duration) + 1;
      } else {
        self.number_of_payment = self.duration;
      }

    },

    duration: function(duration) {
      var self = this;
      if(self.balloon_payment && self.duration > 0) {
        self.number_of_payment = parseInt(self.duration) + 1;
      } else {
        self.number_of_payment = self.duration;
      }
      if(self.first_principal_payment != null && self.first_principal_payment != '' && self.duration != null && self.duration != '') {
        var myDate = new Date(self.first_principal_payment);
        console.log("myDate = ", myDate);
        console.log("MY month = ", myDate.getMonth());
        console.log("duration = ", self.duration);
        var month = parseInt(myDate.getMonth());
        // month = (parseInt(month)) + parseInt(self.duration);
        // console.log("new month = ", month);
        myDate.setMonth((parseInt(month)) + parseInt(self.duration));

        console.log("new myDate = ", myDate);
        var newDate = new Date(myDate);
        console.log("new newDate = ", newDate);
        console.log("new newDate = ", newDate.getMonth());
        self.end_date = self.GetFormattedDate(newDate); //newDate.getMonth() + 1 + "/" + newDate.getDate() + "/" + newDate.getFullYear();
      }
    },
  },

  created: function() {

  },
  mounted: function() {
      var self = this;
      self.getPermissions();
      var path = window.location.pathname;
      var segments = path.split("/");
      if (segments[3]) {
          self.loadDebtNote();

      }
  },
  methods: {
    
    amountFormat(amount) {
        const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits:2,
            maximumFractionDigits:2
        });

        return formatter.format(amount);
    },
    test:function(evt) {
      console.log("test  ==", evt.target.value);
    },
    
    calculation() {
      var self = this;

      var error = false;

      self.note_amount_error_msg = "";

      if (!self.note_amount || self.note_amount == null || self.note_amount == "") {
        self.note_amount_error_msg = "Note Amount is required.";
        error = true;
      }

      self.interest_rate_error_msg = "";
      if (!self.interest_rate || self.interest_rate == null || self.interest_rate == "") {
        self.interest_rate_error_msg = "Interest Rate is required.";
        error = true;
      }

      self.interest_calc_method_error_msg = "";
      if (!self.interest_calc_method || self.interest_calc_method == null || self.interest_calc_method == "") {
        self.interest_calc_method_error_msg = "Interest Calculation Method is required.";
        error = true;
      }

      self.first_principal_payment_date_error = "";
      if (!self.first_principal_payment || self.first_principal_payment == null || self.first_principal_payment == "") {
        self.first_principal_payment_date_error = "First Pricipal Payment Date is required.";
        error = true;
      }

      self.duration_error_msg = "";
      if (!self.duration || self.duration == null || self.duration == "") {
        self.duration_error_msg = "Duration Months are required.";
        error = true;
      }

      self.fixed_payment_error_msg = "";
      if (!self.fixed_payment || self.fixed_payment == null || self.fixed_payment == "") {
        self.fixed_payment_error_msg = "Fixed Payment Amount is required.";
        error = true;
      }

      self.interest_rate_type_error_msg = "";
      if (!self.interest_rate_type || self.interest_rate_type == null || self.interest_rate_type == "") {
        self.interest_rate_type_error_msg = "Interest Rate Type is required.";
        error = true;
      }

      if(!error) {
        var count = 0;
        let originalAmount = self.note_amount.replace(/\,/g,"");
        if(self.lastInstalment != '' && self.lastInstalment != null) {
          console.log("insta === ",self.lastInstalment);
          self.note_amount = self.lastInstalment.note_balance;
          self.duration = self.duration - self.lastInstalment.instalment_number;
          count = self.lastInstalment.instalment_number;
        }

        if(self.interest_calc_method.value == 'B') {
          self.listOfIntereset = self.interest_30_360(self.note_amount.replace(/\,/g,""), self.fixed_payment.replace(/\,/g,""), self.interest_rate,
          self.duration, self.first_principal_payment, self.balloon_payment, count, self.financing_start_date,self.interest_rate_type);
          if(self.listOfIntereset != null && self.listOfIntereset != '' && self.listOfIntereset.length > 0) {
            self.total_interest = self.listOfIntereset[self.listOfIntereset.length-1].interest;
            self.residual_amount = self.listOfIntereset[self.listOfIntereset.length-1].residual;
          }
        } else if (self.interest_calc_method.value == 'A') {
          self.listOfIntereset = self.interest_actual_365(self.note_amount.replace(/\,/g,""), self.fixed_payment.replace(/\,/g,""), self.interest_rate,
          self.duration, self.first_principal_payment, self.balloon_payment, count, self.financing_start_date,self.interest_rate_type);
          if(self.listOfIntereset != null && self.listOfIntereset != '' && self.listOfIntereset.length > 0) {
            self.total_interest = self.listOfIntereset[self.listOfIntereset.length-1].interest;
            self.residual_amount = self.listOfIntereset[self.listOfIntereset.length-1].residual;
          }
        } else if (self.interest_calc_method.value == 'C') {
          self.listOfIntereset = self.interest_actual_360(self.note_amount.replace(/\,/g,""), self.fixed_payment.replace(/\,/g,""), self.interest_rate,
          self.duration, self.first_principal_payment, self.balloon_payment, count, self.financing_start_date,self.interest_rate_type);
          if(self.listOfIntereset != null && self.listOfIntereset != '' && self.listOfIntereset.length > 0) {
            self.total_interest = self.listOfIntereset[self.listOfIntereset.length-1].interest;
            self.residual_amount = self.listOfIntereset[self.listOfIntereset.length-1].residual;
          }
        } else if (self.interest_calc_method.value == 'D') {
          self.listOfIntereset = self.interest_30_365(self.note_amount.replace(/\,/g,""), self.fixed_payment.replace(/\,/g,""), self.interest_rate,
          self.duration, self.first_principal_payment, self.balloon_payment, count, self.financing_start_date,self.interest_rate_type);
          if(self.listOfIntereset != null && self.listOfIntereset != '' && self.listOfIntereset.length > 0) {
            self.total_interest = self.listOfIntereset[self.listOfIntereset.length-1].interest;
            self.residual_amount = self.listOfIntereset[self.listOfIntereset.length-1].residual;
          }
        }

         if(self.lastInstalment != '' && self.lastInstalment != null) {
          self.duration = self.duration +  self.lastInstalment.instalment_number;
          self.note_amount = originalAmount;
        }

        console.log("list = ", JSON.stringify(self.listOfIntereset));
      }
    },
    createDebtNote(flag) {
        var self = this;

        var error = false;

        self.vendor_error_msg = "";
        if (!self.vendor_id || self.vendor_id == null || self.vendor_id == "") {
            self.vendor_error_msg = "Financier is required.";
            error = true;
        }

        self.asset_error_msg = "";
        if (!self.asset || self.asset == null || self.asset == "") {
            self.asset_error_msg = "Asset is required.";
            error = true;
        }

        self.ref_number_error_msg = "";
        if (!self.ref_number || self.ref_number == null || self.ref_number.trim() == "") {
            self.ref_number_error_msg = "Reference Number is required.";
            error = true;
        }

        self.note_amount_error_msg = "";
        if (!self.note_amount || self.note_amount == null || self.note_amount == "") {
            self.note_amount_error_msg = "Note Amount is required.";
            error = true;
        }

        self.interest_rate_error_msg = "";
        if (!self.interest_rate || self.interest_rate == null || self.interest_rate == "") {
            self.interest_rate_error_msg = "Interest Rate is required.";
            error = true;
        }

        self.interest_rate_type_error_msg = "";
        if (!self.interest_rate_type || self.interest_rate_type == null || self.interest_rate_type == "") {
            self.interest_rate_type_error_msg = "Interest Rate Type is required.";
            error = true;
        }

        self.financing_start_date_error = "";
        if (!self.financing_start_date || self.financing_start_date == null || self.financing_start_date == "") {
            self.financing_start_date_error = "Financing Start Date is required.";
            error = true;
        }

        self.first_principal_payment_date_error = "";
        if (!self.first_principal_payment || self.first_principal_payment == null || self.first_principal_payment == "") {
            self.first_principal_payment_date_error = "First Principal Payment Date is required.";
            error = true;
        }

        self.duration_error_msg = "";
        if (!self.duration || self.duration == null || self.duration == "") {
            self.duration_error_msg = "Duration Month(s) required.";
            error = true;
        }

        self.fixed_payment_error_msg = "";
        if (!self.fixed_payment || self.fixed_payment == null || self.fixed_payment == "") {
            self.fixed_payment_error_msg = "Fixed Payment Amount is required.";
            error = true;
        }

        self.payment_type_error_msg = "";
        if (!self.payment_type || self.payment_type == null || self.payment_type == "") {
            self.payment_type_error_msg = "Payment Type is required.";
            error = true;
        }

        self.principal_payment_error_msg = "";
        if (!self.principal_payment || self.principal_payment == null || self.principal_payment == "") {
            self.principal_payment_error_msg = "Principal Payment Type is required.";
            error = true;
        }


        console.log("flag == ", flag);

        self.error_msg = "";
        if (!self.listOfIntereset || self.listOfIntereset.length == 0 && flag != 'update') {
            self.error_msg = "Interest Calculation is required.";
            error = true;
        }

        self.calculation();


        if (!error) {
            self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");
                var id = '';
                if (segments[3])
                {
                    id = segments[3];
                    $("#createdebtNoteBtn").val("Updating ...");
                    $("#createdebtNoteBtn").prop("disabled", true);
                    $("#createdebtNoteBtn").prop("disabled",true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinuedebtNoteBtn").val("Saving ...");
                        $("#createdebtNoteBtn").prop("disabled", true);
                        $("#createAndContinuedebtNoteBtn").prop("disabled", true);
                        $("#createdebtNoteBtn").prop("disabled",true);

                    }else{

                        $("#createdebtNoteBtn").val("Saving ...");
                        $("#createdebtNoteBtn").prop("disabled", true);
                        $("#createAndContinuedebtNoteBtn").prop("disabled", true);
                        $("#createdebtNoteBtn").prop("disabled",true);
                    }

                }

                $.ajax({
                url: process.env.ROOT_API + "/debtnote/create",
                type: "POST",
                data: {
                    id: id,
                    financier: self.vendor_id.value,
                    reference_number: self.ref_number,
                    note_amount: self.note_amount.replace(/\,/g,""),
                    intereset_rate: self.interest_rate,
                    intereset_rate_type: self.interest_rate_type,
                    intereset_calculate_method: self.interest_calc_method.value,
                    payment_method: self.payment_type.value,
                    principal_payment: self.principal_payment.value,
                    financing_start_date: self.financing_start_date,
                    first_principal_payment: self.first_principal_payment,
                    duration: self.duration,
                    number_of_payment: self.number_of_payment,
                    end_date: self.end_date,
                    assetId: self.asset.value,
                    fixed_payment: self.fixed_payment.replace(/\,/g,""),
                    total_interest: self.total_interest,
                    residual_amount: self.residual_amount,
                    is_balloon: self.balloon_payment,
                    list_intereset: self.listOfIntereset,
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createdebtNoteBtn").val("Update");
                        $("#createdebtNoteBtn").prop("disabled", false);
                        $("#canceldebtNoteBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinuedebtNoteBtn").val("Save and Continue");
                            $("#createdebtNoteBtn").prop("disabled", false);
                            $("#createAndContinuedebtNoteBtn").prop("disabled", false);
                            $("#canceldebtNoteBtn").prop("disabled",false);

                        }else{

                            $("#createdebtNoteBtn").val("Save");
                            $("#createdebtNoteBtn").prop("disabled", false);
                            $("#createAndContinuedebtNoteBtn").prop("disabled", false);
                            $("#canceldebtNoteBtn").prop("disabled",false);

                        }
                    }
                    if (data.code == 201){
                        self.$swal('',data.message,'info');
                        return;
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#debtNoteForm").trigger("reset");
                            // self.code = "";
                            self.vendor_id = "";
                            self.reference_number = "";
                            self.note_amount = "";
                            self.intereset_rate = "";
                            self.interest_rate_type = "";
                            self.interest_calc_method = "";
                            self.payment_type = "";
                            self.principal_payment = "";
                            self.financing_start_date = "";
                            self.first_principal_payment = "";
                            self.duration = "";
                            self.number_of_payment = "";
                            self.end_date = "";
                            self.asset = "";
                            self.fixed_payment = "";
                            self.total_interest = "";
                            self.residual_amount = "";
                            self.balloon_payment = false;
                            self.listOfIntereset = [];

                            self.$swal('','Debt Note Created successfully','success');

                        } else if(flag == "update") {

                            if (data.content.id){
                                self.$swal('','Debt Note Updated successfully','success');
                                self.$router.push("/debtnote/view/" + data.content.id);
                            }

                        } else{
                            console.log(data.content);
                            if (data.content.id){
                                self.$swal('','Debt Note Created successfully','success');
                                self.$router.push("/debtnote/view/" + data.content.id);
                            }
                        }

                    } else {
                        self.common_error_msg = data.message;
                        setTimeout(function () {
                            self.common_error_msg = "";
                        }, 10000);
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createdebtNoteBtn").val("Update");
                        $("#createdebtNoteBtn").prop("disabled", false);
                        $("#canceldebtNoteBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#debtNoteForm").trigger("reset");
                            $("#createAndContinuedebtNoteBtn").val("Save and Continue");
                            $("#createdebtNoteBtn").prop("disabled", false);
                            $("#createAndContinuedebtNoteBtn").prop("disabled", false);
                            $("#canceldebtNoteBtn").prop("disabled",false);
                        }else{
                            $("#createdebtNoteBtn").val("Save");
                            $("#createdebtNoteBtn").prop("disabled", false);
                            $("#createAndContinuedebtNoteBtn").prop("disabled", false);
                            $("#canceldebtNoteBtn").prop("disabled",false);
                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-create-data')
                }
                });
      }

    },
    loadDebtNote() {

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/debtnote/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            data: {},
            dataType: "json",
            success: function (data) {
                
                self.loading = false;
                if ( data.status == "success") {

                    self.vendor_id = { text: data.content.vendor_code + " | " + data.content.vendor_name , value: data.content.vendor_id};
                    self.ref_number = data.content.reference_number;
                    self.note_amount = self.amountFormat(data.content.note_amount);
                    self.interest_rate = data.content.intereset_rate;
                    self.interest_rate_type = data.content.intereset_rate_type;
                    if(self.interest_rate_type == 'Fixed') {
                        self.isEditMode = true;
                        self.isFixed = true;
                    } else {
                        self.isEditMode = true;
                        self.isFixed = false;
                    }

                    if ( data.content.status == 'Active' || data.content.status == 'Closed' ) {
                        self.isEditMode = true;
                    } else {
                        self.isEditMode = false;
                        self.isFixed = false;
                    }

                    var idx = self.interestcalcMethodArr.findIndex(obj => obj.value == data.content.intereset_calc_method);
                    if (idx != -1) {
                        self.interest_calc_method = self.interestcalcMethodArr[idx];
                    }

                    var idx = self.paymentTypeArr.findIndex(obj => obj.value == data.content.payment_type);
                    if (idx != -1) {
                        self.payment_type = self.paymentTypeArr[idx];
                    }
                    var idx = self.principalPaymentTypeArr.findIndex(obj => obj.value == data.content.principal_payment_type);
                    if (idx != -1) {
                        self.principal_payment = self.principalPaymentTypeArr[idx];
                    }

                    self.financing_start_date = data.content.financing_start_date;
                    self.first_principal_payment = data.content.first_principal_payment_date;
                    self.duration = data.content.duration;
                    self.number_of_payment = data.content.number_of_payment;
                    self.end_date = data.content.end_date;
                    self.asset = {"text":data.content.asset_number,"value":data.content.vehicle_id};
                    self.fixed_payment = self.amountFormat(data.content.fixed_payment_amount);
                    self.total_interest = data.content.total_interest;
                    self.residual_amount = data.content.residual;
                    if(data.content.is_ballon_payment == 0) {
                      self.balloon_payment = false;
                    } else {
                      self.balloon_payment = true;
                    }
                    self.lastInstalment = data.content.interestRateList;
                }

            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'hvut-invoice-data');
            }
        });
    },
    backScreen(){
        this.$router.go(-1);
    },
    onSearchVendor(search, loading) {
        var self = this;
        self.vendor_error_msg = "";
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vendor_financier', '');
        }
    },
    onSearchVehicle(search, loading) {
        
        var self = this;
        if (search.length > 3) {
            loading(true);
            self.searchField(loading, search, 'vehicle');
        }

    },

  },

}
</script>



// WEBPACK FOOTER //
// src/components/payment/DebtNoteCreate.vue